<template>
  <v-btn
    v-bind="$attrs"
    :block="isBlock"
    deppresed
    elevation="0"
    color="widgetsList--text"
    :style="{border: 'solid 1px #dddddd'}"
    :rounded="layoutShape.roundButton"
    :outlined="layoutShape.button === 'outlined'"
    v-on="$listeners">
    {{ title }}
  </v-btn>
</template>
<script>
export default {
  name: 'BaseSecondaryBtn',
  props: {
    title: { type: String, default () { return '' } },
    isBlock: { type: Boolean, default () { return true } },
  },
  data () {
    return {
      layoutShape: null,
    }
  },
  created () {
    this.layoutShape = this.$store.getters.getConfigJson.layoutShape
  },
}
</script>
